import React, { useContext, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import axios from 'axios';
import { apiRoutes } from '../../AppSettings';
import SuccessAlert from '../shared/SuccessAlert';

const ChangePassword = () => {
    const { userState } = useContext(AuthContext);
    const initialValue = {email: userState.user.userName, currentPassword: '', newPassword: ''};
    const [passwordRequest, setPasswordRequest] = useState(initialValue);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    
    const confirmPassword = e => passwordRequest.newPassword != e.target.value ? 
                                    setErrorMessage("Password should be same as new password") : 
                                    setErrorMessage("");
                                    
    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };

    const handleSubmit = e => {
        e.preventDefault();

        axios.post(apiRoutes.changePassword, JSON.stringify(passwordRequest), options)
		.then((response) => {
		 	if(response.status === 200)
		  	{
              console.log(response);
              setSuccessMessage("Password changed successfully")
              setPasswordRequest(initialValue);
			}
	   }, (error) => {
		  console.log(error);
	  });
    }


    return ( 
        <div className="card">
            <div className="card-body">
                <SuccessAlert message={successMessage}/>
                <div className="row">
                    <div className="col-md-12 col-lg-6">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="form-group">
                                <label>Old Password</label>
                                <input type="password" className="form-control" required onChange={(e) => setPasswordRequest({...passwordRequest, currentPassword: e.target.value}) } />
                            </div>
                            <div className="form-group">
                                <label>New Password</label>
                                <input type="password" className="form-control" required onChange={(e) => setPasswordRequest({...passwordRequest, newPassword: e.target.value}) } />
                            </div>
                            <div className="form-group">
                                <label>Confirm Password</label>
                                <input type="password" className="form-control" required onChange={(e) => confirmPassword(e) } />
                                <div className="error-message">
                                    {errorMessage}
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">Save Changes</button>
                            </div>
                        </form>
                        
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default ChangePassword;